<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>Relazioni</title>
    <path
      d="M14.856,12.648c.785-.688,1.292-1.686,1.292-2.809,0-2.068-1.683-3.75-3.75-3.75s-3.75,1.682-3.75,3.75c0,1.124.507,2.122,1.292,2.81-1.943.924-3.292,2.9-3.292,5.19v1c0,.414.336.75.75.75s.75-.336.75-.75v-1c0-2.344,1.907-4.25,4.25-4.25s4.25,1.906,4.25,4.25v1c0,.414.336.75.75.75s.75-.336.75-.75v-1c0-2.291-1.349-4.267-3.292-5.191ZM10.148,9.839c0-1.241,1.009-2.25,2.25-2.25s2.25,1.009,2.25,2.25-1.01,2.25-2.25,2.25-2.25-1.009-2.25-2.25Z"
      fill="currentColor"
    />
    <path
      d="M18.206,4.385c-1.039,0-1.881.842-1.881,1.881s.842,1.881,1.881,1.881,1.881-.842,1.881-1.881-.842-1.881-1.881-1.881ZM18.206,7.122c-.473,0-.857-.384-.857-.857s.384-.857.857-.857.857.384.857.857-.384.857-.857.857Z"
      fill="currentColor"
    />
    <path
      d="M5.792,10.378c-1.039,0-1.881.842-1.881,1.881s.842,1.881,1.881,1.881,1.881-.842,1.881-1.881-.842-1.881-1.881-1.881ZM5.792,13.115c-.473,0-.857-.384-.857-.857s.384-.857.857-.857.857.384.857.857-.384.857-.857.857Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
